import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { checkoutApi } from "./api/checkoutApi";

// --- Input Selectors ---
const selectCheckoutState = (state: RootState) => state.checkout;
const selectCheckoutDataResult = checkoutApi.endpoints.getCheckoutData.select();

// --- State Selectors ---

export const selectCurrentStep = createSelector(
  [selectCheckoutState],
  (checkout) => checkout.currentStep,
);

export const selectSelectedPaymentMethod = createSelector(
  [selectCheckoutState],
  (checkout) => checkout.selectedPaymentMethod,
);

export const selectIsProcessingCheckout = createSelector(
  [selectCheckoutState],
  (checkout) => checkout.isProcessing,
);

export const selectServerErrors = createSelector(
  [selectCheckoutState],
  (checkout) => checkout.serverErrors,
);

/**
 * Selects the current customer note from Redux state.
 */
export const selectCustomerNote = createSelector(
  [selectCheckoutState],
  (checkout) => checkout.customerNote,
);

export const selectAppointmentSelection = createSelector(
  [selectCheckoutState],
  (checkout) => ({
    date: checkout.appointmentDate,
    time: checkout.appointmentTime,
  }),
);

// --- API Cache Selectors (Single Source of Truth) ---

/**
 * Selects the full transformed checkout data directly from the API cache.
 * Use this instead of a Redux slice copy for addresses/customer data.
 */
export const selectCheckoutApiData = createSelector(
  [selectCheckoutDataResult],
  (checkoutDataResult) => checkoutDataResult.data,
);
